import { createContext, PropsWithChildren, useContext } from 'react';

const HashContext = createContext('');

export default function useHash() {
	const hash = useContext(HashContext);
	if (!hash) {
		throw new Error('useHash must be used within a HashProvider');
	}
	return hash;
}

interface HashProviderProps {
	hash: string;
}

export function HashProvider(props: PropsWithChildren<HashProviderProps>) {
	const { hash, children } = props;
	return <HashContext.Provider value={hash}>{children}</HashContext.Provider>;
}
